'use strict';

// Configuring the Articles module
angular.module('mobile-apps').run(['Menus',
	function(Menus) {
		// Set top bar menu items
		Menus.addMenuItem('topbar', 'Projects', 'projects', 'dropdown', '/#!/projects(/create)?');
		Menus.addSubMenuItem('topbar', 'projects','Projects Overview', '!/#/projects');
		Menus.addSubMenuItem('topbar', 'projects','Create Project', '/#!/projects/create');

	}
])

/**
 * Displays strings only up to a max length and if longer it adds dots to the end
 */
.filter('ellipsisTextLimit', function() {
	return function(input, maxCharacters) {
		if (!input) {
			return '';
		}
		var textLength = input.length;

		if (textLength > maxCharacters) {
			return input.substr(0, maxCharacters - 3) + '...';
		}

		return input;
	};
});
